import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@src/components/Button/Button';

/** IntersectionObserver follows the nearest scroll container, including sheets. */
export function ScrollLoadMore({ loading, onLoad, testId }: { loading: boolean; onLoad: () => void; testId: string }) {
  const host = useRef<HTMLDivElement>(null);
  const { i18n } = useTranslation();
  useEffect(() => {
    if (loading || !host.current) return;
    let requested = false;
    const observer = new IntersectionObserver(entries => {
      if (!requested && entries.some(entry => entry.isIntersecting)) {
        requested = true;
        onLoad();
      }
    });
    observer.observe(host.current);
    return () => observer.disconnect();
  }, [loading, onLoad]);
  return <div ref={host} data-testid={testId} aria-busy={loading}>
    <Button variant="ghost" fullWidth loading={loading} disabled={loading} onClick={onLoad}>{i18n.language.startsWith('ru') ? 'Загрузить ещё' : 'Load more'}</Button>
  </div>;
}
